(function ($) {
  $(function () {
    // slick初始化
    initImgObjectFit()
    initSlick()
    bindSlickEvents();
    let resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initSlick, 200);
    });
    function initSlick() {
      if (window.innerWidth <= 900) {
        if (!$(".bundle_product_new .bundle_product_new_left_imgmain_body").hasClass('slick-initialized')) {
          $(".bundle_product_new .bundle_product_new_left_imgmain_body").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            waitForAnimate: false,
            infinite: false,
            asNavFor: '.bundle_product_new .bundle_product_new_left_imgthumb_body'
          });
        }

        if (!$('.bundle_product_new .bundle_product_new_left_imgthumb_body').hasClass('slick-initialized')) {
          $('.bundle_product_new .bundle_product_new_left_imgthumb_body').slick({
            variableWidth: true,
            slidesToScroll: 1,
            asNavFor: '.bundle_product_new .bundle_product_new_left_imgmain_body',
            focusOnSelect: true,
            waitForAnimate: false,
            infinite: false,
            arrows: false
          });
        }
      } else {
        if ($(".bundle_product_new .bundle_product_new_left_imgmain_body").hasClass('slick-initialized')) {
          $(".bundle_product_new .bundle_product_new_left_imgmain_body").slick('unslick');
        }

        if ($('.bundle_product_new .bundle_product_new_left_imgthumb_body').hasClass('slick-initialized')) {
          $('.bundle_product_new .bundle_product_new_left_imgthumb_body').slick('unslick');
        }
      }
    }
    // 调整图片显示方式
    function adjustImageFit(img, index) {
      const aspectRatio = img.naturalWidth / img.naturalHeight;
      if ((aspectRatio > 1 && index < 3) || aspectRatio >= 1 && index >= 3) {
        img.style.objectFit = 'cover';
      } else {
        img.style.objectFit = 'contain';
      }
    }
    function initImgObjectFit() {
      document.querySelectorAll(".bundle_product_new_left_imgmain_item img").forEach((item, index) => {
        adjustImageFit(item, index)
      })

      document.querySelectorAll(".bundle_product_new_left_imgthumb_item img").forEach((item, index) => {
        adjustImageFit(item, index)
      })
    }
    function bindSlickEvents() {
      $(document)
        .off('click.slickPrev')
        .on('click.slickPrev', ".bundle_product_new .bundle_product_new_left_imgmain_prev", function () {
          $(".bundle_product_new .bundle_product_new_left_imgmain_body").slick("slickPrev");
        });

      $(document)
        .off('click.slickNext')
        .on('click.slickNext', ".bundle_product_new .bundle_product_new_left_imgmain_next", function () {
          $(".bundle_product_new .bundle_product_new_left_imgmain_body").slick("slickNext");
        });
    }

    // 规格切换
    const bundle_prodcuts = document.querySelectorAll(".bundle_card_modal_product")
    bundle_prodcuts.forEach(item => {
      const type = item.getAttribute("data-type")
      const img = item.querySelector(".bundle_card_modal_product_img")
      const product_data = JSON.parse(
        item.querySelector('.bundle_card_modal_product_data').textContent
      );
      const product = product_data.product
      const currency_symbol = product_data.symbol
      let variant
      const option_selects = item.querySelectorAll(".bundle_card_modal_product_option_item")

      option_selects.forEach(select => {
        select.addEventListener("click", () => {
          if (select.classList.contains("bundle_card_modal_product_option_item_active") || select.classList.contains("bundle_card_modal_product_option_item_diasbled")) return
          const select_parent = select.closest(".bundle_card_modal_product_option")
          // const select_title = select_parent.querySelector(".bundle_card_modal_product_option_text span")
          select_parent.querySelector(".bundle_card_modal_product_option_item_active").classList.remove("bundle_card_modal_product_option_item_active")
          select.classList.add("bundle_card_modal_product_option_item_active")
          if (type === "chairs") {
            const color = select.getAttribute("data-color")
            const material = select.getAttribute("data-material")
            variant = product.variants.find(variant => variant.option1 === material && variant.option2 === color)
            // select_title.innerHTML = color + " - " + material
          }
          if (type === "accessories") {
            const color = select.getAttribute("data-color")
            variant = product.variants.find(variant => variant.option1 === color)
            // select_title.innerHTML = color
          }
          if (type === "desk") {
            const select_type = select_parent.getAttribute("data-type")
            const value = select.getAttribute("data-value")
            // select_title.innerHTML = select_type === "Color" ? value : value + " " + select.getAttribute("data-size").replaceAll('/', '"')
            if (select_type === "Color") {
              const variants = product.variants.filter(variant => variant.option1 === value && variant.available)
              const size_selects = item.querySelectorAll(".bundle_card_modal_product_option[data-type='Size'] .bundle_card_modal_product_option_item")
              size_selects.forEach(size_select => {
                size_select.classList.remove("bundle_card_modal_product_option_item_diasbled")
                const size_value = size_select.getAttribute("data-value")
                if (!variants.find(variant => variant.option2 === size_value)) {
                  size_select.classList.add("bundle_card_modal_product_option_item_diasbled")
                }
              })
              const active_size = item.querySelector(".bundle_card_modal_product_option[data-type='Size'] .bundle_card_modal_product_option_item_active").getAttribute("data-value")
              variant = variants.find(variant => variant.option2 === active_size)
              if (!variant) {
                variant = variants[0]
                size_selects.forEach(size_select => {
                  size_select.classList.remove("bundle_card_modal_product_option_item_active")
                  const size_value = size_select.getAttribute("data-value")
                  if (size_value === variant.option2) {
                    size_select.classList.add("bundle_card_modal_product_option_item_active")
                    item.querySelector(".bundle_card_modal_product_option[data-type='Size'] .bundle_card_modal_product_option_text span").innerHTML = size_value + " " + size_select.getAttribute("data-size").replaceAll('/', '"')
                  }
                })
              }

            }
            if (select_type === "Size") {
              const active_color = item.querySelector(".bundle_card_modal_product_option[data-type='Color'] .bundle_card_modal_product_option_item_active").getAttribute("data-value")
              variant = product.variants.find(variant => variant.option1 === active_color && variant.option2 === value)
            }
            changePriceShow(item, variant, currency_symbol)
          }
          img.src = variant.featured_image.src
          const index = item.getAttribute("data-index")
          document.querySelectorAll(".bundle_product_new_left_imgmain_item")[index].querySelector("img").src = variant.featured_image.src
          document.querySelectorAll(".bundle_product_new_left_imgthumb_item")[index].querySelector("img").src = variant.featured_image.src
          item.setAttribute("data-id", variant.id)
        })
      })
    })

    function changePriceShow(item, variant, currency_symbol) {
      const product_price_op = priceToCents(item.getAttribute("data-price"))
      bundle_dp = bundle_dp - product_price_op + variant.price
      bundle_op = bundle_op - product_price_op + variant.price
      document.querySelectorAll(".bundle_product_new_buybox_price_info_discount").forEach(item => {
        item.innerHTML = formatPrice(bundle_dp, currency_symbol)
      })
      document.querySelectorAll(".bundle_product_new_buybox_price_info_op").forEach(item => {
        item.innerHTML = formatPrice(bundle_op, currency_symbol)
      })
      document.querySelector(".bundle_card_modal_salebox_list_dp").innerHTML = formatPrice(bundle_dp, currency_symbol)
      document.querySelector(".bundle_card_modal_salebox_list_op").innerHTML = formatPrice(bundle_op, currency_symbol)
    //   document.querySelectorAll(".product_infor_simplicity_right_buybox_price_afterpay_mowith").forEach(item => {
    //     item.innerHTML = formatPrice(bundle_dp / 12, currency_symbol)
    //   })
      document.querySelectorAll(".product_infor_simplicity_right_buybox_price_afterpay_sixmowith").forEach(item => {
        item.innerHTML = formatPrice(bundle_dp / 4, currency_symbol)
      })

      const bundle_price = document.querySelector(".bundle_card_modal_saletotal_text")
      const saletotal_dp = priceToCents(bundle_price.querySelector(".bundle_card_modal_saletotal_dp").innerHTML)
      const saletotal_op = priceToCents(bundle_price.querySelector(".bundle_card_modal_saletotal_op").innerHTML)
      bundle_price.innerHTML =
        `Was
      <span class="bundle_card_modal_saletotal_dp">${formatPrice((saletotal_dp - product_price_op + variant.price), currency_symbol)}</span>
      <span class="bundle_card_modal_saletotal_op">${formatPrice((saletotal_op - product_price_op + variant.price), currency_symbol)}</span>
      `
      item.setAttribute("data-price", formatPrice(variant.price, currency_symbol))
    }

    // 价格格式化
    function priceToCents(priceStr) {
      if (!priceStr) return 0;

      let clean = priceStr.replace(/[\p{Sc}\s]/gu, '');

      const hasCommaDecimal = /,\d{1,2}$/.test(clean);
      if (hasCommaDecimal) {
        clean = clean.replace(/\./g, '').replace(',', '.');
      } else {
        const dot3Match = /\.\d{3}$/.test(clean) && !/,/.test(clean);
        if (dot3Match) {
          clean = clean.replace(/\./g, '');
        } else {
          clean = clean.replace(/,/g, '');
        }
      }

      const num = parseFloat(clean);
      if (isNaN(num)) return 0;

      return Math.round(num * 100);
    }

    function formatPrice(cents, symbol = '$') {
      if (typeof cents !== 'number' || isNaN(cents)) return '';

      const amount = cents / 100;

      const map = {
        '$': { locale: 'en-US', currency: 'USD' },
        '€': { locale: 'de-DE', currency: 'EUR' },
        '£': { locale: 'en-GB', currency: 'GBP' },
      };

      const { locale, currency } = map[symbol] || map['$'];

      // 使用 Intl 格式化
      let formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(amount);

      // 把货币符号去掉再手动放前面
      formatted = formatted.replace(/[^\d.,\s]+/g, '').trim();

      // 手动加货币符号在前
      return symbol + formatted;
    }

    // 加购和购买
    document.querySelectorAll(".bundle_product_new_right_buybox_btns_btn").forEach((btn) => {
      btn.addEventListener("click", async (event) => {
        const type = btn.getAttribute("data-type");
        const cartIcon = document.querySelector(".header--cart .header__icon--cart");
        let cartFormData = { items: [] };
        document.querySelectorAll(".bundle_card_modal_product").forEach(item => {
          cartFormData.items.push({ id: item.getAttribute("data-id"), quantity: 1 })
        })
        document.querySelectorAll(".bundle_card_modal_freebox_item").forEach(item => {
          cartFormData.items.push({ id: item.getAttribute("data-id"), quantity: 1 })
        })
        btn.classList.add("is_loading");
        if (type === "add_to_cart") {
          try {
            await fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(cartFormData),
            });

            Shopify.getCart((cartTotal) => {
              // document.body.classList.add("cart-sidebar-show");
              updateSidebarCart(cartTotal);
            });
          } finally {
            btn.classList.remove("is_loading");
            setTimeout(() => cartIcon?.click(), 0);
          }
        }
        if (type === "buy_it_now") {
          // const fb_act_data = JSON.parse(document.getElementById('fb_act_data').textContent);
          // fb_act_data.num_items = Number(quantityInput.value)
          // fb_act_data.value = safeMul(Number(quantityInput.value), fb_act_data.value)
          // fbq('track', 'AddToCart', fb_act_data);
          // const gtag_act_data = JSON.parse(document.getElementById('gtag_act_data').textContent);
          // gtag_act_data.items.quantity = Number(quantityInput.value)
          // gtag_act_data.value = safeMul(Number(quantityInput.value), gtag_act_data.value)
          // gtag_act_data.ecomm_totalvalue = gtag_act_data.value
          // gtag("event", "add_to_cart", gtag_act_data)
          const API_VERSION = '2025-07';
          const GRAPHQL_URL = `/api/${API_VERSION}/graphql.json`;
          const STOREFRONT_TOKEN = '1cfa75c81ed9da0f16d4ac611c76231e';

          async function buyNow(items) {
            const mutation = `
            mutation cartCreate($input: CartInput!) {
              cartCreate(input: $input) {
                cart {
                  id
                  checkoutUrl
                }
                userErrors {
                  field
                  message
                }
                warnings {
                  code
                  message
                }
              }
            }
          `;

            const variables = {
              input: {
                lines: items.map(item => ({
                  quantity: item.quantity,
                  merchandiseId: `gid://shopify/ProductVariant/${item.id}`
                }))
              }
            };

            const res = await fetch(GRAPHQL_URL, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
              },
              body: JSON.stringify({ query: mutation, variables })
            }).then(r => r.json());

            const errors = res.data.cartCreate.userErrors;
            if (errors && errors.length) {
              console.error('CartCreate Errors:', errors);
              return;
            }

            window.location.href = res.data.cartCreate.cart.checkoutUrl;
          }

          // 使用示例
          btn.classList.add("is_loading");
          buyNow(cartFormData.items).finally(() => {
            btn.classList.remove("is_loading");
          });
        }
      });
    });

    //底部悬浮栏展示监测判断
    toggleBottomBar();
    function toggleBottomBar() {
      const targetSelector = ".bundle_product_new";
      const bottomBar = document.querySelector(".bundle_product_new_bottom_bar");

      if (!bottomBar) return;

      function initObserver(target, threshold) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                bottomBar.style.zIndex = -1;
                bottomBar.style.opacity = 0;
              } else {
                bottomBar.style.zIndex = 100;
                bottomBar.style.opacity = 1;
              }
            });
          },
          {
            root: null,
            threshold: threshold
          }
        );

        observer.observe(target);
      }

      waitForElement(targetSelector, (target) => {
        initObserver(target, 0.3)
      });
    }

    // 等待元素dom加载
    function waitForElement(selector, callback) {
      const element = document.querySelector(selector);
      if (element) {
        callback(element);
        return;
      }

      const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector(selector);
        if (element) {
          obs.disconnect();
          callback(element);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  })
})(jQuery);